export default "__VITE_ASSET__BVzAgXEu__"